module.exports = __webpack_public_path__ + "img/grp-part-4-corporateculture.19fc8d67.png";